import { render, staticRenderFns } from "./block.vue?vue&type=template&id=6ec008d0&scoped=true&"
import script from "./block.vue?vue&type=script&lang=js&"
export * from "./block.vue?vue&type=script&lang=js&"
import style0 from "./block.vue?vue&type=style&index=0&id=6ec008d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec008d0",
  null
  
)

export default component.exports